import { DirectiveResult, TemplateResult, ovl } from ".."
import { SYSSeqId } from "../global/globals"
import type { ReplaceSnackContentType } from "./snack/actions"
import type { SnackType } from "./snack/snack"

export const SnackTrackedReplaceContent = (
  content: ReplaceSnackContentType
) => {
  ovl.getActions().ovl.internal._ReplaceSnackContent(content)
}

export const SnackAdd = (
  text: string | DirectiveResult | TemplateResult,
  type: SnackType = "Information",
  durationMs: number = 4000,
  cancelable?: boolean,
  onCancel?: () => void
) => {
  ovl
    .getActions()
    .ovl.internal._AddSnack({ text, type, durationMs, cancelable, onCancel })
}
export const SnackTrackedAdd = (
  text: string,
  type: SnackType = "Information",
  key?: string,
  cancelable?: boolean,
  onCancel?: () => void
) => {
  if (!key) {
    key = SYSSeqId()
  }
  ovl.getActions().ovl.internal._AddSnack({
    text,
    type,
    durationMs: 999999,
    key,
    cancelable,
    onCancel,
  })
  return key
}
export const SnackTrackedRemove = (key: string) => {
  setTimeout(() => {
    ovl.getActions().ovl.internal._RemoveSnack(key)
  }, 1000)
}
